"use strict";

import angular from "angular";

import template from "./help-center.component.html";
import "./themes/help-center-dark.component.scss";
import "./themes/help-center.component.scss";

import _ from "lodash";

import { User } from "../../../gateway/User/User";
import { Events } from "../../../presentation/services/Events/Events";

import { Features } from "./features";
import { Helpers } from "./helpers";

class HelpCenterComponent {
    constructor(CentralSidenavService, DSNDialogService, $state, $stateParams) {
        this.User = new User();
        this.Events = new Events();
        this.$stateParams = $stateParams;
        this.CentralSidenavService = CentralSidenavService;
        this.DSNDialogService = DSNDialogService;
        this.$state = $state;
        this.Features = Features;
        this.helpers = Helpers;
    }

    $onInit() {}

    $onDestroy() {}

    $onChanges(changes) {
        if (changes.user && _.get(changes, "user.currentValue._id")) {
            this.CentralSidenavService.setFeaturesCount();
        }
    }
    openChatHubsSpot() {
        this.CentralSidenavService.close();
        window.HubSpotConversations.widget.open();
    }

    parseModuleEvent(module) {
        return module.replace(/\s/g, "");
    }
    async onSelectTabNews() {
        this.CentralSidenavService.setCount(0);
    }

    goToCentral() {
        this.Events.send("menu.centralconhecimento");

        window.open("https://ajuda.nucont.com/centraldeconhecimento", "_blank");
    }

    openNucontMaterials() {
        this.Events.send("menu.workshops");
        window.open(`https://pages.nucont.com/workshops`, "_blank");
    }
    onCustomAction(feature) {
        feature.customAction({ $state: this.$state });
    }
}

HelpCenterComponent.$inject = [
    "CentralSidenavService",
    "DSNDialogService",
    "$state",
    "$stateParams"
];

const name = "helpCenterComponent";
const def = {
    bindings: {
        user: "<"
    },
    controller: HelpCenterComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
